function initQuantity(quantityEl) {
  const inputEl = quantityEl.querySelector('.js-quantity-input')

  quantityEl
    .querySelector('.js-quantity-increase')
    .addEventListener('click', () => inputEl.stepUp())
  quantityEl
    .querySelector('.js-quantity-decrease')
    .addEventListener('click', () => inputEl.stepDown())
}

export function initQuantities() {
  document.querySelectorAll('.js-quantity').forEach(initQuantity)
}
